import { useEffect, useState } from "react";
import { api } from "./api";

let cache = null;
let inflight = null;
const subs = new Set();

function applyFavicon(c) {
    const icon = c?.site_logo_icon;
    if (!icon) return;
    const link = document.querySelector("link[rel~='icon']");
    if (link) link.href = icon;
}

async function load(force = false) {
    if (cache && !force) return cache;
    if (!inflight) {
        inflight = api
            .get("/content")
            .then((r) => {
                cache = r.data || {};
                applyFavicon(cache);
                subs.forEach((f) => f(cache));
            })
            .catch(() => {})
            .finally(() => {
                inflight = null;
            });
    }
    return inflight;
}

export function refreshSiteContent() {
    cache = null;
    return load(true);
}

export function useSiteContent() {
    const [content, setContent] = useState(cache || {});
    useEffect(() => {
        const f = (v) => setContent({ ...v });
        subs.add(f);
        load().then((v) => {
            if (v) setContent({ ...v });
        });
        return () => subs.delete(f);
    }, []);
    return content;
}

export const logoIcon = (c) => c?.site_logo_icon || "/logo-icon.png";
export const logoFull = (c) => c?.site_logo_url || "/logo-full.png";
